import styled from 'styled-components';
import { Colors, Metrics } from '.';
import TextField from '@material-ui/core/TextField';
import AutorenewIcon from '@material-ui/icons/Autorenew';

const StyledComponents = {
  MainContentContainer: styled.div`
    height: 100%;
    min-height: 100%;
    flex: 1;
    overflow: auto;
    padding: 6px 30px 30px 40px;
    &::-webkit-scrollbar {
      width: 15px;
      background-color: ${Colors.black};
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background-color: ${Colors.hoverGrey};
      border: 4px solid ${Colors.black};
      background-clip: padding-box;
      -webkit-border-radius: 7px;
    }
    @media (max-width: ${Metrics.breakpoints.lg - 1}px) {
      padding: 60px 25px 25px 25px;
    }
    @media (max-width: ${Metrics.breakpoints.sm - 1}px) {
      padding: 60px 0 0 0;
      &::-webkit-scrollbar {
        width: 0;
        background: transparent;
      }
    }
  `,
  ControllersMainContentContainer: styled.div`
    height: 100%;
    min-height: 100%;
    flex: 1;
    overflow: auto;
    padding: 6px 30px 30px 40px;
    &::-webkit-scrollbar {
      width: 15px;
      background-color: ${Colors.black};
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background-color: ${Colors.hoverGrey};
      border: 4px solid ${Colors.black};
      background-clip: padding-box;
      -webkit-border-radius: 7px;
    }
    @media (max-width: ${Metrics.breakpoints.lg + Metrics.controllersAddToLg - 1}px) {
      padding: 60px 25px 25px 25px;
    }
    @media (max-width: ${Metrics.breakpoints.sm + 200 - 1}px) {
      padding: 60px 0 0 0;
      &::-webkit-scrollbar {
        width: 0;
        background: transparent;
      }
    }
  `,
  StyledTextField: styled(TextField)`
    & .MuiInputBase-input,
    .MuiFormLabel-root,
    .MuiFormLabel-root.Mui-focused {
      color: ${Colors.blackText};
    }
    & .MuiFormLabel-root {
      font-style: italic;
      font-size: 16px;
    }
    & .MuiInputLabel-shrink {
      font-style: normal;
      font-size: 13px;
    }
  `,
  SpinningRefresh: styled(AutorenewIcon)`
    -webkit-animation: rotate 2s infinite linear;
    animation: rotate 2s infinite linear;
    @-webkit-keyframes rotate {
      0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
      }
    }
    @keyframes rotate {
      0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
      }
    }
  `,
  LogoCircle: styled.img`
    width: 60px;
    height: 60px;
    border-radius: 30px;
    margin-right: 20px;
    object-fit: contain;
    background-color: ${Colors.white};
  `,
  EmptyCircle: styled.span`
    width: 60px;
    height: 60px;
    border-radius: 30px;
    margin-right: 20px;
    background: ${Colors.lightGrey};
  `,
  ContentGroup: styled.div`
    margin-bottom: 8px;
  `,
  ContentLabel: styled.div`
    color: ${Colors.lightGrey};
    font-size: 12px;
  `,
  ContentLine: styled.div`
    color: ${Colors.white};
    font-weight: 600;
  `,
  ContentLineGroup: styled.div`
    padding: 8px;
  `,
};

export default StyledComponents;
